import { useState } from "react";
import type { FieldError } from "react-hook-form";
import cn from "classnames";
import { ErrorMessage } from "components/ui/ErrorMessage";
import { Input } from "components/ui/Input/Input";
import { FORGOT_PASSWORD_ROUTE, SIGN_IN_ROUTE } from "constants/routesValues";
import { useLocation } from "hooks/useLocation";
import { createRouteAction } from "utils/history.utils";
import { EyeHiddenIcon, EyeIcon } from "../Icons";
import style from "./FormField.module.scss";

type FormFieldProps = {
  disabled?: boolean;
  name: string;
  labelTitle: string;
  type?: string;
  isPassword?: boolean;
  className?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: FieldError;
};

export const FormField = ({
  disabled,
  name,
  labelTitle,
  type = "text",
  isPassword,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
}: FormFieldProps) => {
  const location = useLocation();
  const [isVisiblePassword, setIsVisiblePassword] = useState<boolean>(false);

  const handleVisiblePassword = () => {
    setIsVisiblePassword((prev) => !prev);
  };

  return (
    <div className={style.formField}>
      <div className={style.formFieldLabel}>
        <label className={style.formFieldLabelTitle} htmlFor={name}>
          {labelTitle}
        </label>
        {isPassword && location === SIGN_IN_ROUTE && (
          <span onClick={() => createRouteAction(FORGOT_PASSWORD_ROUTE)} className={style.formFieldLabelForgotPassword}>
            Forgot password?
          </span>
        )}
      </div>
      <div className={style.formFieldInputWrapper}>
        <Input
          disabled={disabled}
          placeholder={placeholder}
          name={name}
          type={isPassword ? (isVisiblePassword ? "text" : "password") : type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          error={error}
          className={cn(
            isPassword && style.formFieldInputPassword,
            isPassword && !isVisiblePassword && style.formFieldInputPasswordHidden
          )}
        />
        {type === "password" && (
          <button
            type="button"
            className={style.formFieldInputPasswordButton}
            onClick={() => {
              !!value.length && handleVisiblePassword();
            }}
          >
            {isVisiblePassword ? <EyeIcon /> : <EyeHiddenIcon />}
          </button>
        )}
      </div>
      <ErrorMessage error={error} />
    </div>
  );
};
